import { Injectable } from '@angular/core';
import { Globals } from '../globals';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AuthHttpService } from "./auth-http.service";
import { TranslateService } from '@ngx-translate/core';
import { CreateDialogComponent } from "../shared/dialogs/create-dialog/create-dialog.component";
import { HttpResponse} from '@angular/common/http';
import { Subject, forkJoin } from 'rxjs';

//для обнуления всех сервисов с датчиками
import { AdminSensorsService } from '../services/admin-sensors.service';
import { SensorsService } from '../services/sensors.service';
import { AnalisisService } from './analisis.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private _user_data: Object;
  private _dataSubject = new Subject<any>();
  public error_data_lang:string;

  constructor(
    public translate: TranslateService,
    public Globals:Globals,
    private http:AuthHttpService,
    public dialog: MatDialog,
    public AdminSensorsService: AdminSensorsService,
    public SensorsService: SensorsService,
    public AnalisisService: AnalisisService,

  ) { }

  private setData(user_data: any) {

  //меняем формат даты под фф и сафари
  if(Boolean(user_data)){
    user_data.account_exp_date = user_data.account_exp_date.replace(' ', 'T').slice(0, 19);
  }

    this._user_data = user_data;
    this.Globals.user = user_data;

    this._dataSubject.next(user_data);
  }

  public user(): Subject<any> {

    if (!Boolean(this._user_data)) {
      this.fetchUser();
    }
    return this._dataSubject;
  }

  public fetchUser(){
    this.http.get('/api/user/data?_userService').subscribe((res:HttpResponse<any>) => {
      let user_data = res.body;
      //console.log('service user_data',user_data);
      this.setData(user_data);

    },(error)=>{
      if (error.status !== 401 && error.status !== 503 && error.status !== 403 && error.status !== 423 && this.Globals.error) {
        this.Globals.error = false;
        this.dialog.open(CreateDialogComponent, <MatDialogConfig>{
          data: {
            act: "error",
            text: this.error_data_lang,
            icon_class: 'dialog-icon-warning',
          }
        });
      }
    });
  }
  public getUserGlobalData(){
    //console.log(' service this._user_data',this._user_data);
    return this._user_data;
  }
  public clearUserGlobalData(){
    this.setData(null);
  }
  public clearSensors(){
    this.AnalisisService.cleanSensorLists();
    this.SensorsService.clearSensorsGlobalData();
    this.AdminSensorsService.clearSensorsGlobalData();
  }

  onLangChanged(){
    forkJoin([
      this.translate.get('error_data')
    ]).subscribe((res) =>{
      this.error_data_lang = res[0];
    });
  }
}
